import SkeletonFrame, { SkeletonType } from '../SkeletonFrame/SkeletonFrame';
import { type SkeletonLoaderProps } from './types/propTypes';
import styles from './SkeletonLoader.module.scss';

const SkeletonLoader = ({
  isRoundCorner = true,
  height = '',
  borderRadius = '',
  className = '',
  width = '',
}: SkeletonLoaderProps) => {
  const propsObj: { [key: string]: string | number | boolean } = {
    heightValue: height,
    borderRadiusValue: borderRadius,
    className,
    isRoundCorner,
    widthValue: width,
  };

  return (
    <div className={styles['skeleton-loader-container']} data-testid="skeleton-loader">
      <SkeletonFrame type={SkeletonType.FULL_WIDTH} {...propsObj} />
    </div>
  );
};
SkeletonLoader.displayName = 'SkeletonLoader';
export default SkeletonLoader;
